import React, { useRef } from "react"
import { Card } from "../../atoms/"
import { AosWrapper } from "../../molecules/AosWrapper"
import {
  CardContent,
  LargeScreenSection,
  MultipleSector,
  MultipleSectorContent,
  MultipleSectorHeader,
  ScrollTrack,
  SectorCard,
  SectorCards,
  SectorContent,
  SectorDescription,
  SectorDetails,
  SectorIcon,
  SectorSnapItem,
  StickyViewport,
  SectorTitle,
  HeadlineText,
  DescripitionText,
} from "./style"
import { contents, desktopContent } from "./type"
import { useSectorScrollSpy } from "./hook"
import { useNestedScroll } from "../../hooks/useNestedScroll"
import { StyledGradientTitle } from "../../../utils"

const MultipleSectorComponent: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null)
  const scrollableRef = useRef<HTMLDivElement>(null)
  const { activeId, hoverId, setHoverId, sectorRefs, handleClick } =
    useSectorScrollSpy(sectionRef, scrollableRef, {
      stickyTop: 106,
      mobileStickyTop: 96,
    })
  useNestedScroll(sectionRef, scrollableRef, {
    stickyTop: 106,
    mobileStickyTop: 96,
  })

  const getVisualState = (id: string) => {
    const keys = contents.map((c) => c.id)
    const activeIndex = keys.indexOf(activeId)
    const currentIndex = keys.indexOf(id)

    const diff = currentIndex - activeIndex

    if (diff === 0) return "active"
    if (diff === -1 || diff === 1) return "near"
    return "far"
  }

  return (
    <ScrollTrack ref={sectionRef}>
      <StickyViewport>
        <MultipleSector id={"our-expirence"}>
          <AosWrapper>
            <MultipleSectorContent>
              <MultipleSectorHeader>
                <HeadlineText>
                  {"Ever-ready team to Challenge Problems in "}
                  <StyledGradientTitle>
                    {"Multiple Sectors"}
                  </StyledGradientTitle>
                </HeadlineText>
                <DescripitionText>
                  {
                    "Readytowork delivers innovative solutions across multiple sectors, combining technology, creativity, and strategy to help businesses scale and succeed."
                  }
                </DescripitionText>
                <LargeScreenSection>
                  {desktopContent?.map((content) => {
                    return (
                      <CardContent
                        key={content.id}
                        $active={activeId === content.id}
                        $hover={hoverId === content.id}
                        onClick={() => handleClick(content.id)}
                        onMouseEnter={() => setHoverId(content.id)}
                        onMouseLeave={() => setHoverId(null)}
                      >
                        <img
                          src={
                            activeId === content.id
                              ? content.iconActive
                              : hoverId === content.id
                              ? content.iconHover
                              : content.iconDefault
                          }
                          alt={content.title}
                          width={42}
                          height={32}
                        />

                        <p
                          className={`content ${
                            activeId === content.id ? "activeText" : ""
                          }`}
                        >
                          {content?.title}
                        </p>
                      </CardContent>
                    )
                  })}
                </LargeScreenSection>
              </MultipleSectorHeader>
              <SectorCards id={"sector"} ref={scrollableRef}>
                {contents.map((content, index) => (
                  <SectorSnapItem
                    key={content.id}
                    ref={(el) => (sectorRefs.current[content.id] = el)}
                    data-id={content.id}
                    data-state={getVisualState(content.id)}
                  >
                    <Card
                      gradientBorder={true}
                      hideShadow={true}
                      gradientBorderBottom={"1px"}
                      borderRadius={"50px"}
                      key={index}
                    >
                      <SectorCard>
                        <SectorContent>
                          <SectorIcon>
                            <img src={content.icon_link} />
                          </SectorIcon>

                          <SectorDetails>
                            <SectorTitle>{content.title}</SectorTitle>
                            <SectorDescription>
                              {content.description}
                            </SectorDescription>
                          </SectorDetails>
                        </SectorContent>
                      </SectorCard>
                    </Card>
                  </SectorSnapItem>
                ))}
              </SectorCards>
            </MultipleSectorContent>
          </AosWrapper>
        </MultipleSector>
      </StickyViewport>
    </ScrollTrack>
  )
}

export { MultipleSectorComponent }
